import information from "@dhl-official/icons/information.svg";
import { DhlText } from "@dhl-official/react-library";
import React from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import { Icon } from "root/libs/ui-components/src";

const Root = styled("div")({
  alignItems: "flex-start",
  color: "var(--dui-colors-foreground-secondary)",
  display: "flex",
  flexDirection: "row",
  gap: "var(--dui-size-space-2x)",
  justifyContent: "flex-start",
  marginTop: "var(--dui-size-space-8x)",

  "@media screen and (min-width: 48rem)": {
    marginBottom: "var(--dui-size-space-2x)",
    marginTop: "auto",
  },
});

export const ImportShipmentNote = () => (
  <Root>
    <Icon icon={information} size="small" />
    <DhlText size="sm">
      <FormattedMessage id="tradeLaneComponent.importShipmentNote" />
    </DhlText>
  </Root>
);
